// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__bINsG","loaderOuter":"PageOverlayLoader_loaderOuter__3s2Gl"};